import { DateTime } from 'luxon'

import { ScheduleResponseDTO } from '@core/api/dtos/response/schedule/schedule'
import { Schedule, ScheduleMetadata } from '@core/api/entities/schedule'

import { TimeslotMapper } from './timeslotMapper'

export class ScheduleMapper {
	static toEntity = (dto: ScheduleResponseDTO): Schedule => {
		return new Schedule({
			id: dto.id,
			title: dto.title,
			titleTranlations: dto.title_translations,
			description: dto.description,
			descriptionTranlations: dto.description_translations,
			contentCategoryIds: dto.content_category_ids,
			public: dto.public,
			resellerId: dto.reseller_id,
			hash: dto.hash,
			metadata: ScheduleMetadata.create({
				smallCovers: dto.metadata.small_covers,
				mediumCovers: dto.metadata.medium_covers,
			}),
			favorite: dto.favorite,
			reviewed: dto.reviewed,
			createdAt: DateTime.fromISO(dto.created_at),
			updatedAt: DateTime.fromISO(dto.updated_at),
			timeslots:
				dto.timeslots?.data.map((timeslot) =>
					TimeslotMapper.toEntity(timeslot)
				) || [],
		})
	}

	static toEntities = (dtos: ScheduleResponseDTO[]): Schedule[] => {
		return dtos.map(this.toEntity)
	}
}
